import * as Tabs from '@radix-ui/react-tabs'
import type { ReactNode } from 'react'
import { useSlidingThumb } from '@/lib/useSlidingThumb'
import { cn } from '@/lib/utils'

interface SlidingTabsListProps {
  value: string
  children: ReactNode
  className?: string
}

export const slidingTabTrigger =
  'relative z-10 shrink-0 whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium text-ink-soft transition-colors duration-150 data-[state=active]:text-ink'

export function SlidingTabsList({ value, children, className }: SlidingTabsListProps) {
  const { containerRef, thumb } = useSlidingThumb(value, '[data-state="active"]')

  return (
    <Tabs.List
      ref={containerRef}
      className={cn(
        'scrollbar-none relative inline-flex max-w-full items-center gap-0.5 overflow-x-auto rounded-lg border border-hairline bg-fill-2 p-0.5',
        className,
      )}
    >
      <span
        aria-hidden
        className="pointer-events-none absolute bottom-0.5 top-0.5 rounded-md bg-surface shadow-card transition-[transform,width] duration-200 ease-spring"
        style={{
          width: thumb.width,
          transform: `translateX(${thumb.left - 2}px)`,
          opacity: thumb.ready ? 1 : 0,
        }}
      />
      {children}
    </Tabs.List>
  )
}
